import React from "react";

// Customizable Area Start

import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import {
  Box,
  Button, Typography
} from "@mui/material";
import {
  
} from "@mui/material/styles";
import { Applogo } from "./assets";
// Customizable Area End

import HeaderController, {
  Props,
} from "./HeaderController";

export default class Header extends HeaderController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

// Customizable Area Start

  render() {
    return (
      <Box
        sx={{
          backgroundColor: "#110F12",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          color: "#fff",
          position: "sticky",
          width: "100vw",
          flexWrap: "wrap",
        }}
      >
        <Box component="img" src={Applogo} alt="HubbleMeet Logo"
          sx={{ height: 36, padding: "26px 0px 26px 160px", alignItems: 'center', justifyContent: "center", }} />
        <Box sx={{ padding: "18px 160px 18px 0px" }}>
          <Button data-test-id="connect-button" onClick={() => this.scrollConnectSection()} sx={webStyle.linkTabs}><Typography sx={webStyle.links}>Connect</Typography></Button>
          <Button data-test-id="pitch-button" onClick={() => this.scrollPitchSection()} sx={webStyle.linkTabs}><Typography sx={webStyle.links}>HubbleMeet Pitch</Typography></Button>
          <Button onClick={() => this.props.navigation.navigate("EmailAccountLoginBlock")} sx={webStyle.loginButton} >
          <PersonOutlineIcon sx={{ fontSize: 32, color: "#fff" }} />
            <Typography style={{
              fontWeight: 600,
              fontSize: "22px",
              lineHeight: "30px",
              color: "#fff", 
              padding: "4px 6px",
            }}>Log in</Typography>
          </Button>
        </Box>
      </Box>
    );
  }
}
// Customizable Area End

// Customizable Area Start
const webStyle = {
  footer: {
    backgroundColor: "#111", 
    color: "#fff",
    padding: "30px 20px",
    textAlign: "center",
  },
  qrSection: {
    textAlign: "center",
  },
  linkTabs: {
    color: "#fff",
    marginRight: "10px",
  },
  links: {
    lineHeight: "24px",
    fontFamily: "var(--font-family-inter)",
    fontSize: "22px",
    fontWeight:"bold",
    textTransform: "none"
  },
  loginButton: {
    backgroundColor: "#292524",
    borderRadius: "50px",
    textAlign: "center",
    textTransform: "none",
  }

}
// Customizable Area End
